import { isContractVersionSupported } from '../utils/contractVersion';
import type { MessageBase } from '../types/message';
import type { GraphResolver } from './graphResolver';
import type {
  Service,
  Contrat,
  Champ,
  Action,
  Membre,
  Pair,
} from '../types/contract';

/**
 * Update graph cache with decrypted message.
 * Message must have types.types_names_chiffres (MessageBase). Skips otherwise.
 */
export function updateGraphFromMessage(
  decrypted: unknown,
  graphResolver: GraphResolver,
): void {
  try {
    const msg = decrypted as MessageBase;
    const raw = msg?.types?.types_names_chiffres;
    if (typeof raw !== 'string' || raw.length === 0) {
      console.warn(
        '[SyncService] message missing types.types_names_chiffres, skipped',
        { uuid: (msg as { uuid?: string })?.uuid },
      );
      return;
    }
    const typeNames = raw.toLowerCase();

    if (typeNames.includes('service')) {
      graphResolver.addService(msg as unknown as Service);
    } else if (typeNames.includes('contrat')) {
      const c = msg as unknown as Contrat;
      if (!isContractVersionSupported(c.version)) {
        console.warn(
          `[SyncService] Contrat ${c.uuid} version ${c.version} not supported, skipped`,
        );
        return;
      }
      graphResolver.addContrat(c);
    } else if (typeNames.includes('champ')) {
      graphResolver.addChamp(msg as unknown as Champ);
    } else if (typeNames.includes('action')) {
      graphResolver.addAction(msg as unknown as Action);
    } else if (typeNames.includes('membre')) {
      graphResolver.addMembre(msg as unknown as Membre);
    } else if (typeNames.includes('pair')) {
      graphResolver.addPair(msg as unknown as Pair);
    }
  } catch (error) {
    console.error('Error updating graph:', error);
  }
}
